<template>
    <div class="row">
        <div>
            <h4>Popular apps</h4>
            <p>Explore the most installed apps in the HubSpot Marketplace</p>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/1.png" class="avatar avatar-25 job-icon mb-2 d-inline-block ">
                    </div>
                    <h5>Gmail</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Bring HubSpot to your inbox with the HubSpot integration for Gmail.</p>
                    </div>
                    <span class="text-warning d-block line-height mt-0">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star text-gray"></i>
                        <small class="text-dark">400</small>
                    </span>
                    <small class="mt-2">
                        <span><span>10,000</span>+ installs</span>
                    </small>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/2.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Google Calendar</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Bring HubSpot to your inbox with the HubSpot integration for Gmail.</p>
                    </div>
                    <span class="text-warning d-block line-height mt-0">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star text-gray"></i>
                        <small class="text-dark">189</small>
                    </span>
                    <small class="mt-2">
                        <span><span>10,000</span>+ installs</span>
                    </small>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/8.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>HubSpot for WordPress</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Integrate HubSpot's lead capture and contact management with WordPress</p>
                    </div>
                    <span class="text-warning d-block line-height mt-0">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star text-gray"></i>
                        <small class="text-dark">61</small>
                    </span>
                    <small class="mt-2">
                        <span><span>10,000</span>+ installs</span>
                    </small>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div>
            <h4>New apps</h4>
            <p>Recent additions worth checking out</p>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Channelyze</h5>
                    <small>Built by Channelyze Ltd</small>
                    <div class="mt-2">
                        <p class="mb-0">Manage channel sales and partner renewals through HubSpot.</p>
                    </div>
                    <div class="mt-4">
                        <small>New</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Showpad by Elixir Solutions</h5>
                    <small>Built by Elixir Solutions</small>
                    <div class="mt-2">
                        <p class="mb-0">Add Showpad email activity in HubSpot</p>
                    </div>
                    <div class="mt-4">
                        <small>New</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Ion by Rock Content</h5>
                    <small>Built by Rock Content</small>
                    <div class="mt-2">
                        <p class="mb-0">Content experiences your audience will love</p>
                    </div>
                        <div class="mt-4">
                        <small>New</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div>
            <h4>Free apps</h4>
            <p>Explore free apps in the HubSpot Marketplace</p>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Alexa Helper</h5>
                    <small>Built by Voicify</small>
                    <div class="mt-1">
                        <p class="mb-0">Access your HubSpot data in real time through Amazon's Alexa</p>
                    </div>
                    <div class="mt-4">
                        <small><span><span>50</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Magento 2 Sync by Unific</h5>
                    <small>Built by Unific | HubSpot Ecommerce Integrations</small>
                    <div class="mt-1">
                        <p class="mb-0">Take Data Driven Actions With Enriched Ecommerce Data</p>
                    </div>
                    <div class="mt-1">
                        <small><span><span>40</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Pendo for HubSpot</h5>
                    <small>Built by Pendo</small>
                    <div class="mt-1">
                        <p class="mb-0">Create product experiences people love</p>
                    </div>
                    <div class="mt-4">
                        <small><span><span>50</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div>
            <h4>Built by HubSpot</h4>
            <p>Explore apps built and supported by HubSpot</p>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/5.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Facebook Messenger</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Manage all Messenger conversations and bots in HubSpot</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star text-gray"></i>
                        <small class="text-dark">21</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>10,000</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Airtable</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Data Sync - Sync Airtable rows (with emails) with HubSpot</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star half text-gray"></i>
                        <i class="fa fa-star text-gray"></i>
                        <small class="text-dark">3</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>500</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/9.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Mailchimp</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Data Sync - Sync contacts two-way with a Mailchimp Audience</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star text-gray"></i>
                        <i class="fa fa-star text-gray"></i>
                        <small class="text-dark">22</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>3,500</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div>
            <h4>Workflow integrations</h4>
            <p>Explore apps you can leverage within HubSpot workflows.</p>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>360NRS</h5>
                    <small>Built by Net Real Solutions</small>
                    <div class="mt-2">
                        <p class="mb-0">Send individual SMS to your contacts or use workflows to send bulk SMS</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">3</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>50</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Aloware</h5>
                    <small>Built by Aloware</small>
                    <div class="mt-2">
                        <p class="mb-0">Dialer, calling & texting automations with real-time logging & syncing</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">4</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>100</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>SMS for HubSpot</h5>
                    <small>Built by MessageMedia</small>
                    <div class="mt-2">
                        <p class="mb-0">Send and receive SMS without leaving HubSpot. Get started in minutes.</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">13</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>300</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div>
            <h4>Data sync built by HubSpot</h4>
            <p>Explore powerful and easy-to-use two-way data sync for 25+ apps, built by HubSpot</p>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/7.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Google Contacts</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0"></p>Sync Google Contacts with HubSpot contacts
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">50</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>9000</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/9.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Mailchimp</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Data Sync - Sync contacts two-way with a Mailchimp Audience</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">22</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>3,500</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Stripe</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Data Sync - Sync Stripe and HubSpot customers</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">10</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>1,000</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div>
            <h4>Marketing campaign apps</h4>
            <p>Explore apps that can help optimize your marketing campaign efforts in HubSpot.</p>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Databox</h5>
                    <small>Built by Databox, Inc</small>
                    <div class="mt-2">
                        <p class="mb-0">Popular KPI/Analytics Dashboards Amongst HubSpot Customers</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">35</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>10,000</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Forminator</h5>
                    <small>Built by WPMU DEV</small>
                    <div class="mt-2">
                        <p class="mb-0">Easy-to-create forms, polls, and quizzes for WordPress.</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">3</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>1,000</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Lucky Orange</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2"><p>Improve customer experience with recordings</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">16</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>1,500</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div>
            <h4>Media bridge apps</h4>
            <p>Combine the power of HubSpot’s CRM platform with your favorite media apps</p>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Wistia</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0"></p>Sync Google Contacts with HubSpot contacts
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">50</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>9000</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/9.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Mailchimp</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Data Sync - Sync contacts two-way with a Mailchimp Audience</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">22</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>3,500</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 col-md-4">
            <div class="card cardhover">
                <div class="card-body">
                    <div>
                        <img src="@/assets/images/market/3.png" class="avatar avatar-25 job-icon mb-2 d-inline-block">
                    </div>
                    <h5>Stripe</h5>
                    <small>Built by HubSpot</small>
                    <div class="mt-2">
                        <p class="mb-0">Data Sync - Sync Stripe and HubSpot customers</p>
                    </div>
                    <span class="text-warning d-block line-height mt-2">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <small class="text-dark">10</small>
                    </span>
                    <div class="mt-2">
                    <small><span><span>1,000</span>+ installs</span></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'market1'
}
</script>
